"use client";

import React from "react";
import dayjs from "dayjs";
import { useWatch } from "react-hook-form";
import advancedFormat from "dayjs/plugin/advancedFormat";

import { Badge } from "@/components/ui/badge";
import { Paragraph } from "@/components/ui/typography";

dayjs.extend(advancedFormat);

function CourseTags({ course, languages }) {
  const courseMode = useWatch({ name: "mode" });
  const languageId = useWatch({ name: "languageId" });

  const courseLanguage = React.useMemo(
    () => languages?.find((lang) => lang.languageId === languageId),
    [languages, languageId]
  );

  return (
    <div className="flex gap-x-3">
      <Paragraph variant="b5" weight="sb" className="text-primary" asChild>
        <Badge
          variant="outline"
          className="bg-grayscale border-primary-bg-strong rounded-full capitalize"
        >
          {courseMode}
        </Badge>
      </Paragraph>

      {courseLanguage && (
        <Paragraph variant="b5" weight="sb" className="text-secondary" asChild>
          <Badge
            variant="outline"
            className="bg-grayscale border-secondary-bg-strong rounded-full"
          >
            {courseLanguage.languageName}
          </Badge>
        </Paragraph>
      )}

      {course.batchStartDate && (
        <Paragraph variant="b5" weight="sb" asChild>
          <Badge
            variant="outline"
            className="bg-grayscale border-grayscale-line rounded-full"
          >
            Batch Start: {dayjs(course.batchStartDate).format("Do MMM YYYY")}
          </Badge>
        </Paragraph>
      )}
    </div>
  );
}

export default CourseTags;
